import { Color } from '../models/Color';


export const colors: Color[] = [
    {
        name: 'Blue',
        value: 'BLUE_WHITE'
    },
    {
        name: 'Red',
        value: 'RED_WHITE'
    },
    {
        name: 'Yellow',
        value: 'YELLOW_WHITE'
    }
]


// WEBPACK FOOTER //
// ./src/mockup/colors.ts